import React from 'react';
import { Result } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const EmptyPage = () => {
  const { t } = useTranslation();
  return (
    <Result
      status="404"
      title="404"
      subTitle={t('Sorry, the page you visited does not exist!')}
      extra={<Link to="/">{t('Back DashBoard')}</Link>}
    />
  );
};

export default EmptyPage;
